module.exports = __webpack_public_path__ + "static/img/sys_doc.973390f0.png";